import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, forwardRef, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import { clone } from 'lodash';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AbstractInputControlComponent } from 'src/app/shared/models/base-inputs';
import { QuizLabelOption } from '../../models/quiz-question.model';

@Component({
  selector: 'app-quiz-label-anatomy-select',
  templateUrl: './quiz-label-anatomy-select.component.html',
  styleUrls: ['./quiz-label-anatomy-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => QuizLabelAnatomySelectComponent),
      multi: true
    }
  ]
})
export class QuizLabelAnatomySelectComponent extends AbstractInputControlComponent<string> implements OnInit, OnDestroy {

  @Input()
  public get options(): QuizLabelOption[] {
    return this._options;
  }
  public set options(value: QuizLabelOption[]) {
    // Note: display by name ascending
    const copiedOptions = clone(value);
    this._options = copiedOptions.sort((a, b) => {
      const aTitle = a.label.title;
      const bTitle = b.label.title;
      return aTitle.localeCompare(bTitle);
    });
    this.changeRef.markForCheck();
  }
  private _options: QuizLabelOption[];

  @Input()
  outline = true;

  @Output()
  valueChange = new EventEmitter<string[]>();

  form: FormGroup;
  valueControl: FormControl;

  private ngUnsubscribe = new Subject();

  constructor(
    private formBuilder: FormBuilder,
    private changeRef: ChangeDetectorRef) {
    super();
    this.form = this.formBuilder.group({
      value: ['']
    });
    this.valueControl = this.form.get('value') as FormControl;
  }

  ngOnInit(): void {
    this.initFormListeners();
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  initFormListeners() {
    this.form.valueChanges
      .pipe(
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe(({ value }) => {
        this.writeValue(value);
        this.valueChange.next(value);
      });
  }

  setDisabledState(disabled: boolean): void {
    super.setDisabledState(disabled);   
    // set disabled
    if (disabled) {
      this.form.disable();
    } else {
      this.form.enable();
    }
    this.changeRef.markForCheck();
  }

  setFormValues(value: string) {
    this.valueControl.setValue(value);
    this.changeRef.markForCheck();
  }

  getSelectedOption() {
    const selectedValue = this.valueControl.value;
    return this.options
      .find((option) => option.value === selectedValue);
  }
}
